import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { CLOUD_MODE } from './lib/deployment';
const App = lazy(() =>
  CLOUD_MODE
    ? import('./cloud/CloudApp').then((m) => ({ default: m.CloudApp }))
    : import('./App').then((m) => ({ default: m.App })),
);
import { resolveDeviceCode } from './lib/device-identity';
import { KioskSessionProvider } from './lib/session';
import { KioskThemeProvider } from './lib/theme';
import './styles/index.css';

// render 前消化 URL ?device= 佈建參數（寫入 localStorage 並從網址移除），
// 確保 App 首次 render 時機台身分（device_code）已就緒。
if (!CLOUD_MODE) resolveDeviceCode();
else {
  const referrer = document.createElement('meta');
  referrer.name = 'referrer';
  referrer.content = 'no-referrer';
  document.head.appendChild(referrer);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <KioskThemeProvider>
          <KioskSessionProvider>
            <Suspense fallback={<p>載入中…</p>}>
              <App />
            </Suspense>
          </KioskSessionProvider>
        </KioskThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
